module.exports = __webpack_public_path__ + "static/media/simple-brush.c81fdef1.png";